import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { withStyles, Button, Container, Select, FormControl, InputLabel, MenuItem, TextField } from '@material-ui/core';
import { ADD_KEY, UPDATE_KEY } from '../../core/handlers.actions';

const styles = (theme: any) => ({
    root: { '& .MuiTextField-root': { margin: theme.spacing(1), width: '100%' } },
    editBox: { borderTop: '2px solid #f50057', borderLeft: '2px solid #f50057', borderRight: '2px solid #f50057' },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        width: '100%',
        marginBottom: 60
    },
    formControlSelect: {
        margin: theme.spacing(1),
        minWidth: 120,
        width: '100%',
        marginBottom: 30
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
});

interface Props {
    reset: () => void;
    addKey: (key: any) => void;
    updateKey: (key: any) => void;
    keyId: any;
    keys: any;
    classes: any;
}

interface State {
    error: boolean;
    name: any;
    isActive: any;
    _id: any;
    key: any;
}

class KeyForm extends Component<Props, State> {
    state: State = { _id: null, error: false, name: '', isActive: null, key: null };
    constructor(props: Props) {
        super(props);
        this.setKey = this.setKey.bind(this);
        this.cancel = this.cancel.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.submit = this.submit.bind(this);
        this.update = this.update.bind(this);
    }

    componentDidMount() {
        const { keyId } = this.props;
        if (!keyId) return console.log('No key this is a new key');
        return this.setKey(keyId);
    }

    public setKey(id: string) {
        const { keys } = this.props;
        const result = keys.find((key: any) => key._id === id);
        if (!result) return console.log('No key to setup, this is a new setup');
        const { name, isActive, _id, key } = result;
        this.setState({ ...this.state, _id, name, isActive, key});
    }

    public cancel() {
        const { reset } = this.props;
        this.setState({ ...this.state, name: '', isActive: null, _id: null, key:null });
        reset();
    }

    public inputChangeHandler(e: any) {
        const { name, value } = e.target;
        if (name === 'isActive') return this.setState({ ...this.state, [name]: value === 0 ? false : true });
        return this.setState({ ...this.state, [name]: value });
    }

    public update() {
        const { reset, updateKey } = this.props;
        const { _id, name, isActive } = this.state;
        updateKey({ _id, name, isActive });
        this.setState({ ...this.state, name: '', isActive: null, _id: null, key:null });
        reset();
    }

    public submit() {
        const { addKey, reset } = this.props;
        const { _id, name, isActive } = this.state;
        addKey({ _id, name, isActive });
        this.setState({ ...this.state, name: '', isActive: null, _id: null, key: null });
        reset();
    }

    public render() {
        const { classes } = this.props;
        const { error, _id, name, isActive, key } = this.state;
        const edit = _id ? true : false;
        const accountStatusSelector = isActive ? 1 : 0;
        return (
            <div>
                <form className={classes.root} noValidate autoComplete="off">    
                {edit ? <h2>Update Key</h2> : <h2>Add New Key</h2>}
                <Container>
                    {edit ?
                        <TextField label="Key Value" value={key}  inputProps={{ readOnly: true }}/>
                        : null
                    }
                    <TextField error={error} required name="name" label="Key Name" value={name || ''} onChange={this.inputChangeHandler} />
                    <FormControl className={classes.formControlSelect}>
                        <InputLabel>Key Status</InputLabel>
                        <Select onChange={this.inputChangeHandler} name="isActive" value={accountStatusSelector || 0}>
                            <MenuItem value={1}>Active</MenuItem>
                            <MenuItem value={0}>Inactive</MenuItem>
                        </Select>
                    </FormControl>
                    {edit ?
                        <div><Button variant="contained" color="primary" onClick={this.update}>Update Key</Button>&nbsp;&nbsp;<Button variant="contained" color="secondary" onClick={this.cancel}>Cancel</Button></div>
                        :
                        <div><Button variant="contained" color="primary" onClick={this.submit}>Add Key</Button>&nbsp;&nbsp;<Button variant="contained" color="secondary" onClick={this.cancel}>Cancel</Button></div>}
                </Container>
                </form>
            </div>
        );
    }
}

const mapProps = (app: any) => ({ keys: app.rootReducer.keys });
const mapDispatch = (dispatch: Dispatch) => ({
    addKey: (data: any) => dispatch({ type: ADD_KEY, payload: data }),
    updateKey: (data: any) => dispatch({ type: UPDATE_KEY, payload: data })
});

export default connect(mapProps, mapDispatch)(withStyles(styles)(KeyForm));